import MainHeading from "../../../components/comman/MainHeading";
import moment from "moment";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import CommonTable from "../../../components/comman/CommonTable";
import { formatAmount } from "../../../utility/CommonFunctions";
import ViewIcon from "../../../components/Icons/ViewIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import { useSelector } from "react-redux";
export default function MyPaySlip() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    paySlipList: [],
    sortByDate: [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
    isLoadingGeneratePayslip: false,
  });

  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    GetPaySlip();
  }, [
    pageStates?.sortByDate,
    pageStates?.currentPage,
    pageStates?.pageSize,
  ]);

  const GetPaySlip = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_monthly_user_salary + `?userId=${userDetails?.id}&` + MainFilterHandler(pageStates);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.userSalary?.map((item) => ({
          ...item,
          empNameWithImage: item?.name + "##" + item?.profilePhoto,
          basicSalary: item?.["Basic Salary"]
            ? formatAmount(item?.["Basic Salary"])
            : "--",
          grossSalary: item?.["Gross Salary"]
            ? formatAmount(item?.["Gross Salary"])
            : "--",
          netSalary: item?.["Net Salary"]
            ? formatAmount(item?.["Net Salary"])
            : "--",
          deductionAmount: item?.["Gross Salary"]
            ? formatAmount(item?.["Gross Salary"] - item?.["Net Salary"])
            : "--",
        }));
        setPageStates((pre) => ({
          ...pre,
          paySlipList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const singleDateChangeHandler = (date) => {
    if (!date || !moment(date).isValid()) return;

    const selectedStartDate = moment(date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const selectedEndDate = moment(date).endOf("month").format("YYYY-MM-DD");
    setPageStates((prevState) => ({
      ...prevState,
      sortByDate: [selectedStartDate, selectedEndDate],
    }));
  };

  const HandleViewPayslip = (data) => {
    if (!data?.["Basic Salary"]) {
      const [year, month] = pageStates?.sortByDate?.[0]?.split("-") || [];
      const shortMonths = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const date = `${shortMonths[month - 1]} - ${year}`;

      toast.error(`${date} salary is not created yet.`);

      return;
    }
    let options = {
      method: "GET",
    };
    setPageStates((pre) => ({
      ...pre,
      isLoadingGeneratePayslip: true,
    }));
    let API = `${apiUrl?.generate_pay_slip}userId=${data?.id}&startDate=${pageStates?.sortByDate?.[0]}`;
    callApi(API, options).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        isLoadingGeneratePayslip: false,
      }));
      if (response?.status === true) {
        setSelectedDocument({ url: response?.data });
        setModal(true);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeading = [
    { value: "employeeCode", label: "Employee Code" },
    { value: "name", label: "Employee" },
    { value: "basicSalary", label: "Basic Pay" },
    { value: "grossSalary", label: "Gross Pay" },
    { value: "deductionAmount", label: "Deduction" },
    { value: "netSalary", label: "Net Pay" },
  ];

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view payslip",
      clickHandler: HandleViewPayslip,
    },
  ];

  return (
    <>
      {pageStates?.isLoadingGeneratePayslip && <BgBlurLoader />}
      <div className="content">
        <MainHeading
          title={"My Pay Slip"}
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
          pageState={{
            sortBySingleDate: pageStates?.sortByDate
          }}
          pickerType="month"
        />
        <div className="card mb-4">
          <div className="card-body">
            <CommonTable
              TableHeading={TableHeading}
              TableData={pageStates?.paySlipList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
